import { h } from '..//index.js';
export const selectCaseById = (state, id) => {
    const singleCase = state.cases[id];
    if (!h.isLoaded(singleCase)) {
        return null;
    }
    return singleCase.data;
};
export const selectCaseLoadingStateById = (state, id) => {
    const singleCase = state.cases[id];
    return singleCase;
};
export const selectCaseError = (state, id) => {
    const singleCase = state.cases[id];
    if (h.isError(singleCase)) {
        return singleCase.error;
    }
    return null;
};
//# sourceMappingURL=selectors.js.map